import { CommissionQuestionsFormValues } from '@/components/misc/ReferralFlow/CommissionQuestions/types'

export const COMMISSION_QUESTIONS_FORM_FIELDS: Record<
  keyof CommissionQuestionsFormValues,
  keyof CommissionQuestionsFormValues
> = {
  isExpectingCommission: 'isExpectingCommission',
  expectedCommissionAmount: 'expectedCommissionAmount',
  knowsCommissionAmount: 'knowsCommissionAmount',
}
